import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Box, Tabs, Tab, Button } from '@mui/material';
import { useAuth } from '../auth/AuthContext';

const TABS = [
  { label: 'Transactions', to: '/transactions' },
  { label: 'Orders', to: '/orders' },
  { label: 'Items', to: '/items' },
  { label: 'Customers', to: '/customers' },
  { label: 'News', to: '/news' },
  { label: 'Reports', to: '/reports' },
];

const Header = () => {
  const location = useLocation();
  const { user, signOut } = useAuth();
  // Treat '/' as Transactions so the redirect doesn't leave the tab bar blank.
  const path = location.pathname === '/' ? '/transactions' : location.pathname;
  const activeIndex = TABS.findIndex((t) => path.startsWith(t.to));

  return (
    <AppBar
      position="static"
      color="default"
      elevation={0}
      sx={{ borderBottom: '1px solid #e5e7eb', backgroundColor: '#ffffff' }}
    >
      <Toolbar
        sx={{
          maxWidth: 1200,
          mx: 'auto',
          width: '100%',
          minHeight: { xs: 56, sm: 64 },
          justifyContent: 'space-between',
          gap: 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1.5 }}>
          <Typography
            variant="h6"
            sx={{
              fontFamily: '"Quicksand", "Roboto", sans-serif',
              fontWeight: 600,
              letterSpacing: '0.02em',
              color: '#1f2937',
            }}
          >
            The Back Room™
          </Typography>
          <Typography
            variant="overline"
            sx={{ color: '#64748b', letterSpacing: '0.25em', fontWeight: 500 }}
          >
            Admin
          </Typography>
        </Box>
        {user && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Typography
              variant="body2"
              sx={{ color: '#64748b', display: { xs: 'none', sm: 'block' } }}
            >
              {user.email}
            </Typography>
            <Button
              size="small"
              variant="text"
              onClick={signOut}
              sx={{ textTransform: 'none' }}
            >
              Sign out
            </Button>
          </Box>
        )}
      </Toolbar>
      <Box sx={{ maxWidth: 1200, mx: 'auto', width: '100%', px: 2 }}>
        <Tabs
          value={activeIndex === -1 ? 0 : activeIndex}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ minHeight: 40 }}
        >
          {TABS.map((t) => (
            <Tab
              key={t.to}
              label={t.label}
              component={NavLink}
              to={t.to}
              sx={{
                minHeight: 40,
                textTransform: 'none',
                fontWeight: 500,
                fontSize: '0.95rem',
              }}
            />
          ))}
        </Tabs>
      </Box>
    </AppBar>
  );
};

export default Header;
